import React, { useEffect, useState } from 'react';
import PlanningCalendar from './components/PlanningCalendar';
import { PlanningService } from '../../services/planning';
import { Box } from '@mui/material';
import TypographyUI from '../../components/TypographyUI';

const Planning = () => {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrainings = async () => {
      try {
        const { data: res } = await PlanningService.getAllPlannings();

        const allTrainings = res.data.flatMap((day) =>
          day.trainings.map((t) => ({
            ...t,
            date: `${day.date}T${t.time}`,
          }))
        );

        setTrainings(allTrainings);
      } catch (err) {
        console.error('Error fetching trainings:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTrainings();
  }, []);

  if (loading) return <></>;

  return (
    <Box>
      <TypographyUI
        variant="h4"
        fontSize="32px"
        align="left"
        marginBottom="10px"
      >
        Planning
      </TypographyUI>

      <PlanningCalendar trainings={trainings} />
    </Box>
  );
};

export default Planning;
